import { useMutation } from '@tanstack/react-query';
import { type APIBody, type UseMutationHookOptions, apiClient } from '#/api';

export interface SearchMutationPayload {
  /**
   * The data to create the JoggrDoc.
   */
  data: APIBody<'POST /_prv/search'>;
}

/**
 * Search Mutation Function.
 *
 * @api `POST /_prv/search`
 * @param payload The payload for the mutation.
 * @returns The result of the mutation.
 */
export const searchMutationFn = async (payload: SearchMutationPayload) => {
  return apiClient.request('POST /_prv/search', {
    body: {
      query: payload.data.query,
      filters: payload.data.filters,
      include: payload.data.include,
    },
  });
};

/**
 * Search Mutation shareable React Hook.
 *
 * @api `POST /_prv/search`
 * @param options A mutation options object.
 * @returns A mutation result object.
 */
export function useSearchMutation(options?: UseMutationHookOptions) {
  return useMutation({
    ...options,
    mutationFn: searchMutationFn,
  });
}
